export default __webpack_public_path__ + "static/media/icon-user-grey.7830eef4.svg";